import React, { FC } from 'react'
import { Modal, Typography } from '@mui/material'
import tw from 'twin.macro'
import Lottie from 'lottie-react'
import { Button } from 'src/components/shared/Button'

interface ModalWithAnimationProps {
  isOpen: boolean
  onClose?: () => void
  onCancel?: () => void
  title: string
  description?: string
  animationData: object
  cancelText?: string
}

export const ModalWithAnimation: FC<ModalWithAnimationProps> = ({
  isOpen,
  onClose,
  onCancel,
  title,
  description,
  animationData,
  cancelText,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-with-animation-title"
      aria-describedby="modal-with-animation-description"
      css={tw`flex justify-center items-center p-4`}
    >
      <div
        css={tw`bg-white rounded-2xl shadow-xl w-[370px] flex flex-col items-center pt-6 px-4 pb-4`}
      >
        <Lottie loop animationData={animationData} css={tw`w-[210px] h-[164px]`} />

        <Typography
          id="modal-with-animation-title"
          variant="h6"
          css={tw`text-center text-base font-bold my-2`}
        >
          {title}
        </Typography>

        {description && (
          <Typography
            id="modal-with-animation-description"
            variant="body2"
            color="textSecondary"
            css={tw`my-0 text-center text-sm text-[#847E96] px-[35px]`}
          >
            {description}
          </Typography>
        )}
        {onCancel && (
          <Button
            size="medium"
            color="grey"
            onClick={onCancel}
            className={tw`mt-6 py-2 px-8 w-full`}
          >
            {cancelText || 'Cancel'}
          </Button>
        )}
      </div>
    </Modal>
  )
}
